import crvLogo from 'libs/tokens/img/crv.svg';
import crvUsdLogo from 'libs/tokens/img/crvUsd.svg';
import ethLogo from 'libs/tokens/img/eth.svg';
import usdcLogo from 'libs/tokens/img/usdc.svg';
import usdtLogo from 'libs/tokens/img/usdt.svg';
import wbtcLogo from 'libs/tokens/img/wbtc.svg';
import wethLogo from 'libs/tokens/img/weth.svg';
import wstEthLogo from 'libs/tokens/img/wstEth.svg';
import MNTLogo from 'libs/tokens/img/mnt.svg';
// import xvsLogo from 'libs/tokens/img/krai.svg';
import kreiLogo from 'libs/tokens/img/krei.svg'
import type { Token } from 'types';

const mntToken: Token = {
  address: '0x0000000000000000000000000000000000000000',
  decimals: 18,
  symbol: 'MNT',
  asset: MNTLogo,
  isNative: true,
};

export const tokens: Token[] = [
  mntToken,
  {
    address: '0x12710030e9EfDb9b085b7446C50a8aaAb3Aa7921',
    decimals: 18,
    symbol: 'KRAI',
    asset: kreiLogo,
  },
  {
    address: '0x00a92853EC3084F3C52A6c6C2D744cb98b4bcAc3',
    decimals: 18,
    symbol: 'WMNT',
    asset: MNTLogo,
  },
  {
    address: '0x5351197Fc3bc4301F885E2085abe17C14724FdD4',
    decimals: 18,
    symbol: 'WETH',
    asset: wethLogo,
  },
  {
    address: '0x448ca23a0C9d64fEcD4852B29Df0b3193f026300',
    decimals: 6,
    symbol: 'USDC',
    asset: usdcLogo,
  },
];
